import { create } from 'zustand'
import dayjs from 'dayjs'
import { getLastCompleteDate } from '@/lib/date-utils'

// Calculate default dates: 180 days ago, one week period
const lastCompleteDate = getLastCompleteDate()
const defaultEndDate = dayjs(lastCompleteDate.toString())
  .subtract(180, 'day')
  .format('YYYYMMDD')
const defaultStartDate = dayjs(lastCompleteDate.toString())
  .subtract(187, 'day')
  .format('YYYYMMDD')

export const useRecoveryStore = create((set) => ({
  pid: '1',
  country: 'BR',
  startDate: defaultStartDate,
  endDate: defaultEndDate,

  setPid: (pid) => set({ pid }),
  setCountry: (country) => set({ country }),
  setStartDate: (startDate) => set({ startDate }),
  setEndDate: (endDate) => set({ endDate }),
  setDateRange: (startDate, endDate) => set({ startDate, endDate }),
}))
